import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusuriProiecteComponent } from './statusuri-proiecte.component';
import { AddStatusuriProiecteComponent } from './add-statusuri-proiecte/add-statusuri-proiecte.component';
import { EditStatusuriProiecteComponent } from './edit-statusuri-proiecte/edit-statusuri-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        StatusuriProiecteComponent,
        AddStatusuriProiecteComponent,
        EditStatusuriProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [StatusuriProiecteComponent],
})
export class StatusuriProiecteModule { }
